import TutorialAddPage from './add'
export default TutorialAddPage
